module.exports = __webpack_public_path__ + "458f466f57a49df984b2555e4b9dea92.svg";